import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import { darken } from "polished";

const TextStyles = {
  default: {
    color: "whaleGrey",
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: "1.5",
    textTransform: "none"
  },
  sm: {
    fontSize: "14px",
    fontWeight: "normal",
    lineHeight: "1.6",
    textTransform: "none"
  },
  disclaimer: {
    color: "wolfGrey",
    fontSize: "12px",
    lineHeight: "1.3",
    textTransform: "none"
  },
  primaryLg: {
    fontSize: "40px",
    fontWeight: "300",
    lineHeight: "1.3",
    textTransform: "none"
  },
  primaryMd: {
    fontSize: "32px",
    fontWeight: "300",
    lineHeight: "1.3",
    textTransform: "none"
  },
  primarySm: {
    fontSize: "28px",
    fontWeight: "300",
    lineHeight: "1.3",
    textTransform: "none"
  },
  secondary: {
    fontSize: "16px",
    lineHeight: "1.5",
    fontWeight: "600",
    textTransform: "none"
  },
  secondarySmCaps: {
    fontSize: "12px",
    fontWeight: "700",
    lineHeight: "1.3",
    textTransform: "uppercase"
  }
};

const setBaseStyles = (textStyle, defaultTextStyle) => {
  const fontSize = textStyle
    ? TextStyles[textStyle].fontSize
    : TextStyles[defaultTextStyle].fontSize;
  const fontWeight = textStyle
    ? TextStyles[textStyle].fontWeight
    : TextStyles[defaultTextStyle].fontWeight;
  const lineHeight = textStyle
    ? TextStyles[textStyle].lineHeight
    : TextStyles[defaultTextStyle].lineHeight;
  const textTransform = textStyle
    ? TextStyles[textStyle].textTransform
    : TextStyles[defaultTextStyle].textTransform;

  return `
    font-size: ${fontSize};
    font-weight: ${fontWeight};
    line-height: ${lineHeight};
    text-transform: ${textTransform};`;
};

const Link = styled.a`
  -webkit-font-smoothing: antialiased;
  background: none;
  border: 0;
  box-shadow: none;
  cursor: pointer;
  font-family: "Source Sans Pro", Helvetica, Arial, Geneva, sans-serif;
  padding: 0;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

const primaryTouched = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "sm")};
  color: ${colors.primaryTouched};

  &:active {
    color: ${darken(0.2, colors.primaryTouched)};

    @media screen and (max-width: 660px) {
      color: ${darken(0.1, colors.primaryTouched)};
    }
  }

  @media screen and (min-width: 661px) {
    &:hover {
      color: ${darken(0.1, colors.primaryTouched)};
    }
  }
`;

const primaryTouchedBoldUnderline = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "secondarySmCaps")};
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  color: ${colors.primaryTouched};
  font-weight: 700;
  padding: 1px 0;
  text-transform: uppercase;

  &:active {
    border-bottom-color: ${darken(0.1, colors.primaryTouched)};
    color: ${darken(0.1, colors.primaryTouched)};

    @media screen and (max-width: 660px) {
      border-bottom-color: ${colors.primaryTouched};
      color: ${colors.primaryTouched};
    }
  }

  @media screen and (min-width: 661px) {
    &:hover {
      border-bottom-color: ${colors.primaryTouched};
    }
  }
`;

const primaryTouchedUnderline = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "sm")};
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  color: ${colors.primaryTouched};

  &:active {
    border-bottom-color: ${darken(0.1, colors.primaryTouched)};
    color: ${darken(0.1, colors.primaryTouched)};

    @media screen and (max-width: 660px) {
      border-bottom-color: ${colors.primaryTouched};
      color: ${colors.primaryTouched};
    }
  }

  @media screen and (min-width: 661px) {
    &:hover {
      border-bottom-color: ${colors.primaryTouched};
    }
  }
`;

const primary = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "sm")};
  color: ${colors.primary};

  &:active {
    color: ${darken(0.2, colors.primary)};

    @media screen and (max-width: 660px) {
      color: ${darken(0.1, colors.primary)};
    }
  }

  @media screen and (min-width: 661px) {
    &:hover {
      color: ${darken(0.1, colors.primary)};
    }
  }
`;

const primaryBoldUnderline = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "secondarySmCaps")};
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  color: ${colors.primary};
  font-weight: 700;
  padding: 1px 0;
  text-transform: uppercase;

  &:active {
    border-bottom-color: ${darken(0.1, colors.primary)};
    color: ${darken(0.1, colors.primary)};

    @media screen and (max-width: 660px) {
      border-bottom-color: ${colors.primary};
      color: ${colors.primary};
    }
  }

  @media screen and (min-width: 661px) {
    &:hover {
      border-bottom-color: ${colors.primary};
    }
  }
`;

const primaryUnderline = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "sm")};
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  color: ${colors.primary};

  &:active {
    border-bottom-color: ${darken(0.1, colors.primary)};
    color: ${darken(0.1, colors.primary)};

    @media screen and (max-width: 660px) {
      border-bottom-color: ${colors.primary};
      color: ${colors.primary};
    }
  }

  @media screen and (min-width: 661px) {
    &:hover {
      border-bottom-color: ${colors.primary};
    }
  }
`;

const pureBlackBoldUnderline = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "secondarySmCaps")};
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  color: ${colors.pureBlack};
  font-weight: 700;
  padding: 1px 0;
  text-transform: uppercase;

  &:active {
    border-bottom-color: ${colors.pureBlack};
  }

  @media screen and (min-width: 661px) {
    &:hover {
      border-bottom-color: ${colors.pureBlack};
    }
  }
`;

const whaleGrey = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "sm")};
  color: ${colors.whaleGrey};

  &:active {
    color: ${colors.ink};

    @media screen and (max-width: 660px) {
      color: ${colors.whaleGrey};
    }
  }

  @media screen and (min-width: 661px) {
    &:hover {
      color: ${colors.ink};
    }
  }
`;

const whaleGreyUnderline = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "sm")};
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  color: ${colors.whaleGrey};

  &:active {
    border-bottom-color: ${colors.whaleGrey};
  }

  @media screen and (min-width: 661px) {
    &:hover {
      border-bottom-color: ${colors.whaleGrey};
    }
  }
`;

const whiteTeal = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "sm")};
  color: white;

  &:active {
    color: ${colors.highlightTeal};
  }

  @media screen and (min-width: 661px) {
    &:hover {
      color: ${colors.highlightTeal};
    }
  }
`;

const whiteBoldUnderline = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "secondarySmCaps")};
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  color: white;
  font-weight: 700;
  padding: 1px 0;
  text-transform: uppercase;

  &:active {
    border-bottom-color: white;
  }

  @media screen and (min-width: 661px) {
    &:hover {
      border-bottom-color: white;
    }
  }
`;

const whiteUnderline = styled(Link)`
  ${({ textStyle }) => setBaseStyles(textStyle, "sm")};
  border-bottom: 1px solid transparent;
  border-top: 1px solid transparent;
  color: white;

  &:active {
    border-bottom-color: white;
  }

  @media screen and (min-width: 661px) {
    &:hover {
      border-bottom-color: white;
    }
  }
`;

const LinkEnum = {
  primary,
  primaryBoldUnderline,
  primaryTouched,
  primaryTouchedBoldUnderline,
  primaryTouchedUnderline,
  primaryUnderline,
  pureBlackBoldUnderline,
  whaleGrey,
  whaleGreyUnderline,
  whiteBoldUnderline,
  whiteTeal,
  whiteUnderline
};

/**
 * @deprecated replaced by primary
 */
LinkEnum.classicBlue = primary;

/**
 * @deprecated replaced by primaryUnderline
 */
LinkEnum.classicBlueUnderline = primaryUnderline;

/**
 * @deprecated replaced by primaryBoldUnderline
 */
LinkEnum.classicBlueBoldUnderline = primaryBoldUnderline;

/**
 * @deprecated replaced by primaryTouched
 */
LinkEnum.brightBlue = primaryTouched;

/**
 * @deprecated replaced by primaryTouchedUnderline
 */
LinkEnum.brightBlueUnderline = primaryTouchedUnderline;

/**
 * @deprecated replaced by primaryTouchedBoldUnderline
 */
LinkEnum.brightBlueBoldUnderline = primaryTouchedBoldUnderline;

export default LinkEnum;
